<template>
  <div>
    <b-modal
      title="File Upload Utility"
      ref="imageDropZoneAndCropper"
      id="imageDropZoneAndCropperId"
      size="lg"
      hide-footer
    >
      <files-upload-with-cropper v-if="!uploading" @input="uploadFiles" :resizeImagesOnUpload="true"  />
      <div v-else>
        <b-progress
          :value="uploadPercent"
          :max="100"
          show-progress
          animated
        ></b-progress>
      </div>
    </b-modal>
    <table class="table w-100 mt-1 custom-bordered-table" >
      <thead>
        <tr>
          <th style="width: 5%">Order</th>
          <th style="width: 45%">Name</th>
          <th style="width: 40%">Preview</th>
          <th style="width: 10%">Action</th>
        </tr>
      </thead>
      
      <draggable
        v-model="internalFiles"
        tag="tbody"
        @end="onDragEnd"
      >
        <tr 
          v-for="(file, file_index) in internalFiles"
          :key="getFileKey(file)"
          class="draggable-row"
        >
          <!-- Order Number -->
          <td class="align-middle text-center">
            {{ file_index + 1 }}
          </td>

          <!-- File Name -->
          <td class="align-middle">
            <a @click="openFile(file)" class="text-decoration-none cursor-pointer">
              <u class="text-primary">
                {{
                  file && file[0]
                    ? file[0]
                    : file
                    ? getImgSrc(file).split("/").slice(-1).toString()
                    : ""
                }}
              </u>
            </a>
          </td>

          <!-- Preview Image -->
          <td class="align-middle">
            <a @click="openFile(file)" class="cursor-pointer">
              <b-img
                :src="checkIfImage(file) ? getImgSrc(file) : filesDefaultImg"
                v-bind="imgProps"
                class="preview-thumbnail"
                alt="File preview"
              ></b-img>
            </a>
          </td>

          <!-- Delete Action -->
          <td class="align-middle text-center">
            <feather-icon
              size="20"
              class="action-icon"
              @click="
                () => {
                  showModal('Are you sure want to remove?', 'remove').then(
                    (value) => {
                      if (value) removeFile(file_index);
                    }
                  );
                }
              "
              icon="XCircleIcon"
              :hidden="viewOnly"
            />
          </td>
        </tr>
      </draggable>
      <tr>
        <td :colspan="4" class="text-center" :hidden="viewOnly">
          <a @click="openImageUploadModal" class="text-decoration-none cursor-pointer">
            <div style="display: inline-flex; align-items: center; gap: 8px; padding: 20px;">
              <u style="font-weight:600; font-family:Verdana, Geneva, Tahoma, sans-serif; font-size:13px;">Choose file</u>
              <feather-icon icon="UploadIcon" size="20" />
            </div>
          </a>
        </td>
      </tr>
    </table>
    <!-- <a @click="openImageUploadModal" :hidden="viewOnly"
      ><div style="display:flex; padding: 20px; ;flex-direction:row;gap:2%">
        <div style="padding-top:0.5%" ><u style="font-weight:600; font-family:Verdana, Geneva, Tahoma, sans-serif;font-size:13px;">Choose file</u></div>
          <div style="padding-top:0.5%">
          <feather-icon icon="UploadIcon" size="20" style="font-weight:600;font-family:Verdana, Geneva, Tahoma, sans-serif" />
          </div>
      </div> 
    </a> -->
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {
  BCol,
  BRow,
  VBTooltip,
  BModal,
  BButton,
  BProgress,
  BCard,
  BCardText,
  BImg,
} from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import FilesUploadWithCropper from "./FilesUploadWithCropper.vue";
import { uploadMultiFiles } from "@/utils/helpers";
import Ripple from "vue-ripple-directive";
import showModal from "../../components/ModalConfirmation";


export default {
  name: 'FilesContainerNew',
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BCol,
    BRow,
    FeatherIcon,
    VBTooltip,
    BModal,
    FilesUploadWithCropper,
    BButton,
    BProgress,
    BCard,
    BCardText,
    BImg,
    draggable,
  },
  watch: {
    value: {
      handler: 'initializeFiles',
      immediate: true,
      deep: true
    }
  },
  created() {
    this.initializeFiles();
  },
  data() {
    return {
      imgProps: {
        blank: false,
        blankColor: "#777",
        width: 25,
        height: 25,
        class: "m1",
      },
      uploading: false,
      uploadPercent: 0,
      filesDefaultImg: require("@/assets/images/pages/files-documents.png"),
      internalFiles: [],
    };
  },
  props: {
    value: {
      type: [Object, Array],
      default: () => [],
    },
    show_only: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    files_url() {
      return process.env.VUE_APP_FILESURL+ "/";
    },
  },
  methods: {
    showModal,
    getFileKey(file) {
      const path = Array.isArray(file) ? file[1] : file;
      return `file-${path}`;
    },
    onDragEnd() {
      this.internalFiles.forEach((file, index) => {
        if (file.length < 3 || file[2] === undefined) {
          file.push(index + 1);
        }else{
          file[2] = index + 1;
        }
      });
      this.emitInput(this.internalFiles);
      // console.log(this.internalFiles)
    },
    initializeFiles() {
      this.internalFiles = Array.isArray(this.value) ? JSON.parse(JSON.stringify(this.value)) : [];
      this.internalFiles = this.internalFiles.map((file, index) => {
        if (file.length < 3 || file[2] === undefined) {
          file.push(index + 1);
        }
        return file;
      });
    },
    getFileName(file) {
      if (Array.isArray(file)) {
        return file[0];
      } else {
        return "";
      }
    },
    getImgSrc(file) {
      if (Array.isArray(file)) {
        if (file[1]) {
          return this.files_url + file[1];
        }
      } else {
        return this.files_url + file;
      }
    },
    openImageUploadModal() {
      this.$refs["imageDropZoneAndCropper"].show();
    },
    emitInput(files) {
      this.$emit("input", files);
    },
    async uploadFiles(files) {
      this.uploading = true;
      try {
        const filesArr = files.map((f) => f[1]);
        const uploadPaths = await uploadMultiFiles(
          filesArr,
          this.onUploadProgress
        );

        if (uploadPaths && Array.isArray(uploadPaths) && uploadPaths.length) {
          let filesArr =
            this.value && Array.isArray(this.value) ? this.value : [];

          const newArr = uploadPaths.map((uploadPath, index) => [
            files[index][0],
            uploadPath,
          ]);

          filesArr = filesArr.concat(newArr);
          this.emitInput(filesArr);
          this.$refs["imageDropZoneAndCropper"].hide();
        }
      } catch (err) {
        console.error("Error in uploadFiles ", err);
      } finally {
        this.uploading = false;
        this.uploadPercent = 0;
      }
    },
    removeFile(file_index) {
      const updatedFiles = this.internalFiles.filter((_, index) => index !== file_index);
      this.emitInput(updatedFiles);
    },
    openFile(file) {
      if (Array.isArray(file)) {
        if (file[1]) {
          window.open(this.files_url + file[1], "__blank");
        }
      } else {
        window.open(this.files_url + file, "__blank");
      }
    },
    checkIfImage(file) {
      if (!file) return false;
      let uploadPath = "";
      if (Array.isArray(file)) {
        uploadPath = file[1];
      } else {
        uploadPath = file;
      }
      if (
        typeof uploadPath === "string" &&
        uploadPath.match(/\.(png|jpg|jpeg|webp)$/)
      ) {
        return true;
      }
      return false;
    },
    onUploadProgress(progressEvent) {
      this.uploadPercent = parseInt(
        Math.round((progressEvent.loaded / progressEvent.total) * 100)
      );
    },
  },
};
</script>

<style>
.uploadDivContainer {
  border: solid 2px orange;
  border: 5px solid #f3f2f7;
  cursor: pointer;
  width: 100px;
  aspect-ratio: auto 100 / 100;
  text-align: center;
}
.upload-icon {
  height: 45px !important;
  width: 60px !important;
  padding: 0.25rem;
  background-color: #edefff;
  border: 1px solid #dae1e7;
  border-radius: 0.357rem;
}
.f-10 {
  font-size: 8px;
  font-weight: bolder;
}
.file-name {
  height: 1em;
  line-height: 1em;
  overflow: hidden;
}
img {
}
.custom-bordered-table, 
.custom-bordered-table th, 
.custom-bordered-table td {
  border: 1px solid #dee2e6;
  border-collapse: collapse;
}

.custom-bordered-table th, 
.custom-bordered-table td {
  padding: 0.75rem;
}

</style>
<style scoped>
.cursor-pointer { cursor: pointer; }
.preview-thumbnail { max-width: 40px; }
.action-icon:hover { transform: scale(1.1); }
.draggable-row { transition: all 0.3s ease; }
</style>